import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as AmenityService from './../services/amenityService';

import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { parseRatingListRequestParams } from '../utils/commonUtils';
import {
    setListAmenity as setListAmenityAction,
    setAmenityDetail as setAmenityDetailAction,
} from './../actions/amenityAction';
import history from './../helpers/history';

function* getListAmenity() {
    yield takeLatest(Types.AMENITY_LIST_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(AmenityService.getAmenity);
        yield put(setListAmenityAction(result));
    }, errorHandleAmenity(Types.AMENITY_LIST_FAIL)))
}

function* getAmenityDetail() {
    yield takeLatest(Types.AMENITY_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(AmenityService.getAmenityDetail, action.id);
        yield put(setAmenityDetailAction(result));
    }, errorHandleAmenity(Types.AMENITY_DETAIL_FAIL)))
}

function* updateAmenityDetail() {
    yield takeLatest(Types.AMENITY_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(AmenityService.updateAmenityDetail, action.amenity.amenity);
        successHandleAmenity(action, action.amenity.amenity.name);
        yield put(setAmenityDetailAction(action.amenity.amenity));
        history.push(PATHS.AMENITY.LIST.path);
        history.go();
    }, errorHandleAmenity(Types.AMENITY_DETAIL_FAIL)))
}

function* createAmenityDetail() {
    yield takeLatest(Types.AMENITY_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(AmenityService.createAmenityDetail, action.amenity);
        successHandleAmenity(action, action.amenity.name);
        yield put(setAmenityDetailAction(result));
        history.push(PATHS.AMENITY.LIST.path);
        history.go();
    }, errorHandleAmenity(Types.AMENITY_DETAIL_FAIL)))
}

function* deleteAmenityDetail() {
    yield takeLatest(Types.AMENITY_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(AmenityService.deleteAmenityDetail, action.amenity);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.removeSuccess')}`,
        });
        const params = parseRatingListRequestParams(action.filter || {});
        const resultList = yield call(AmenityService.getAmenity, params);
        yield put(setListAmenityAction(resultList));
    }, errorHandleAmenity(Types.AMENITY_DETAIL_FAIL)));
}


/* Transtale Saga */

function* createAmenityTranslate() {
    yield takeLatest(Types.AMENITY_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(AmenityService.createAmenityTranslate, action.amenity);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.amenity.translate.languageName);
        yield put({ type: Types.AMENITY_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.AMENITY_DETAIL_ACTION, id: action.amenity.id });
    }, errorHandleAmenity(Types.AMENITY_FAIL)))
}

function* updateAmenityTranslate() {
    yield takeLatest(Types.AMENITY_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(AmenityService.updateAmenityTranslate, action.amenity);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.amenity.translate.languageName);
        yield put({ type: Types.AMENITY_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.AMENITY_DETAIL_ACTION, id: action.amenity.id });
    }, errorHandleAmenity(Types.AMENITY_FAIL)))
}

function* deleteAmenityTranslate() {
    yield takeLatest(Types.AMENITY_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(AmenityService.deleteAmenityTranslate, action.amenity.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.amenity.translate.languageName);
        yield put({ type: Types.AMENITY_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.AMENITY_DETAIL_ACTION, id: action.amenity.id });
    }, errorHandleAmenity(Types.AMENITY_FAIL)))
}

function successHandleAmenity(action, value) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('notification.createSuccess')}`,
        description: `${i18n.t('item.amenity.title')} "${value}"`
    })
}


function errorHandleAmenity(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'amenity');
}

export function* amenitySaga() {
    yield all([
        fork(getListAmenity),
        fork(getAmenityDetail),
        fork(updateAmenityDetail),
        fork(createAmenityDetail),
        fork(createAmenityTranslate),
        fork(updateAmenityTranslate),
        fork(deleteAmenityDetail),
        fork(deleteAmenityTranslate)
    ])
}
